import React, { FC } from 'react';
import './BirthWishPreview.css';

interface BirthWishPreviewProps {
	contactName: string;
	message: string;
}

const BirthWishPreview: FC<BirthWishPreviewProps> = ({ contactName, message }) => {


	return (
		<div className="BirthWishPreview" data-testid="BirthWishPreview">
			<h2>Bonjour <span>{contactName}</span>,</h2>
			<p>
				Toute l'équipe <strong>ICAZI</strong> a tenu à vous adresser un message personnalisé pour célébrer votre anniversaire :
			</p>
			<blockquote>
				<span>{message}</span>
			</blockquote>
			<p>
				Nous espérons que cette journée sera remplie de sourires, de bons moments et de belles attentions.
			</p>
			<p>
				Très chaleureusement,<br />
				— L'équipe <strong>ICAZI</strong>
			</p>
		</div>
	);
}

export default BirthWishPreview;
